import featherLogo from '../../assets/images/feather_logo.svg'
import MainControls from './MainControls.tsx'
import React, { useState } from 'react'
import Button from '@/components/common/Button.tsx'
import ContextMenu from '@/components/common/ContextMenu.tsx'
import { useAuth0 } from '@auth0/auth0-react'
import Icon from '@/components/common/Icon.tsx'
import AutoSaveIndicator from './AutoSave/AutoSaveIndicator.tsx'
import { forceSave } from '@/shared/store/use-cases/auto-save.ts'

const TopBar: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  const { logout } = useAuth0()

  return (
    <div className="top-bar relative">
      <div className="flex flex-col justify-start gap-2 bg-zinc-700">
        <div className="flex items-center gap-3 text-sm font-light leading-normal text-white">
          <img src={featherLogo} alt="AudioStack Logo" className="h-5" />
        </div>
        {/*<ProjectButton fileName="audio_form_filename.audioform" />*/}
      </div>
      <MainControls isLoading={isLoading} />
      <div className="relative z-[40]">
        <div className="flex flex-row items-center justify-end gap-3">
          <AutoSaveIndicator />
          <Button
            squared
            onClick={() => setIsUserMenuOpen((isOpen) => !isOpen)}
          >
            <Icon name="chevronDown" width={16} />
          </Button>
          <ContextMenu
            viewModel={[
              {
                key: 'ls_generic_logout',
                icon: <Icon name="user" />,
                action: async () => {
                  setIsUserMenuOpen(false)
                  await forceSave()
                  await logout({
                    logoutParams: { returnTo: window.location.origin },
                  })
                },
              },
            ]}
            isOpen={isUserMenuOpen}
            setIsOpen={setIsUserMenuOpen}
            position={{
              right: 0,
              top: 40,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(TopBar)
